import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputFieldModule } from '../input-field/input-field.module';
import { InputSubmitModule } from '../input-submit/input-submit.module';
import { ModalModule } from '../modal/modal.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { RemarksComponent } from './remarks.component';
import { InputSelectModule } from '../input-select/input-select.module';
import { EffectsModule } from '@ngrx/effects';
import { RemarksEffects } from 'src/app/search-result/effects/remarks.effects';

@NgModule({
  declarations: [RemarksComponent],
  imports: [
    CommonModule,
    InputFieldModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    InputSubmitModule,
    ModalModule,
    InputSelectModule,
    EffectsModule.forFeature([RemarksEffects])
  ],
  exports: [RemarksComponent]
})
export class RemarksModule {}
